import { render } from "./TotalByType.vue?vue&type=template&id=7b9d2e79"
import script from "./TotalByType.vue?vue&type=script&lang=js"
export * from "./TotalByType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tio-patinhas/tio-patinhas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__